<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    荷坳站<br>
站点介绍<br>
荷坳站位于龙岗大道及保康路交叉处的西南方，为高架站，车站下方为龙岗大道、东面是荷康路。车站东边是横岗长途汽车站和水晶城小学，东南面是水晶之城，西面是乐城小区。荷坳站装修设计以“荷花”为主题，素雅的白色为底，配以大幅的水墨荷花图，给人以身处荷塘月色中的清幽静谧之美。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:33	23:14	3号线	2分15-20秒	4分30秒<br>
双龙	06:09	23:58	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:34	23:14	3号线	3分15秒	5分钟<br>
双龙	06:12	23:58	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:34	00:14	3号线	3分15秒	5分钟<br>
双龙	06:12	00:58	3号线	3分15秒	5分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道东侧（南）、荷康路、水晶之城、水晶城小学<br><br>
B出入口:<br>
龙岗大道东侧（北）、横岗长途汽车站、龙岗区人民法院横岗人民法庭、长江埔工业区、荷坳派出所、龙岗车管所<br><br>
C出入口:<br>
龙岗大道西侧（北）、联泰路、荷坳社区、荷坳新村、乐城、乐城公园<br><br>
D出入口:<br>
龙岗大道西侧（南）、信联路、坳背路、龙岗乐城小学、全顺祥科技园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 荷坳地铁站<br>
351,358,366,833，M229,M239,M266，M268,M294,M314,M357,M359,M368,M386,M394,M466<br><br>
B出入口:<br>
公交站名： 荷坳地铁站<br>
351,358,366,833，M229,M239,M266，M294,M314,M357,M359,M368,M386,M394,M466<br><br>
C出入口:<br>
公交站名： 荷坳地铁站<br>
351,358,366,833，M229,M239,M266，M268,M294,M314,M357,M359,M368,M386,M394,M466<br><br>
D出入口:<br>
公交站名： 荷坳地铁站<br>
351,358,366,833，M229,M239,M266，M268,M294,M314,M357,M359,M368,M386,M394,M466<br>

</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


